export const Validate = {
  Required: (value) => { return !!value.length }
}

export default { Validate }
